import { render, staticRenderFns } from "./login.mpx?vue&type=template&id=a3254408&scoped=true&component=true&componentId=login72216026"
import script from "./login.mpx?vue&type=script&lang=js&component=true&componentId=login72216026"
export * from "./login.mpx?vue&type=script&lang=js&component=true&componentId=login72216026"
import style0 from "./login.mpx?vue&type=style&index=0&id=a3254408&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m72216026%22%7D&component=true&componentId=login72216026"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3254408",
  null
  
)

export default component.exports